<template>
  <div id="app"
       class="security">
    <!-- 导航 -->
    <nav-bar :activeIndex="3"></nav-bar>
    <div class="banner"></div>
    <div class="news_content main_container"
         id="here">
      <!-- 免责声明 -->
      <div class="duty_text"
           id="tips">
        <div class="duty_content">
          <div class="title">
            关于格乐立
            <span class="right_text">®</span>我应该知道的最重要的信息
          </div>
          <div class="content">
            使用前您应该和医生了解格乐立
            <span class="right_text">®</span>的获益和潜在风险。格乐立
            <span class="right_text">®</span>是一种肿瘤坏死因子（TNF）拮抗剂，可降低免疫系统抗感染的能力。如果您有任何类型的感染，在医生认可前不应使用格乐立
            <span class="right_text">®</span>。
            <div class="cicle_content">
              <div class="circle"></div>
              <strong>严重感染可能</strong>
            </div>
            <div class="cicle_content">
              <p>
                <span style="position: relative; top: -0.2rem;"
                      class="circle"></span>
                <strong>
                  &nbsp;&nbsp;&nbsp;&nbsp;使用格乐立
                  <span class="right_text">®</span>治疗有可能增加严重感染风险，可能导致住院或死亡。这些严重感染包括活动性结核病（包括潜伏性结核感染重新激活）、侵袭性真菌感染、细菌、病毒和由其它条件致病菌导致的感染。
                </strong>
                <span>
                  在开始使用格乐立
                  <span class="right_text">®</span>之前，医生应该检查您是否患有结核病或潜伏性结核可能，包括仔细检查是否有结核病的症状、体征和做相关的结核筛查检测。即使您的结核筛查检测为阴性，如果医生觉得您有风险，可能建议您先接受结核病药物的治疗。在使用格乐立
                  <span class="right_text">®</span>治疗期间和治疗后，您也要定期复查，排除各种严重感染发生的风险。您如果患有慢性或复发性感染，在开始使用格乐立
                  <span class="right_text">®</span>治疗前应综合考虑治疗的潜在风险和获益。
                </span>
              </p>
            </div>
            <div class="cicle_content">
              <div class="circle"></div>
              <strong>恶性肿瘤可能</strong>
            </div>
            <div class="cicle_content">
              <p>
                <span class="circle"></span>&nbsp;&nbsp;&nbsp;&nbsp;对于使用TNF拮抗剂(包括格乐立
                <span class="right_text">®</span>)的儿童和成人来说，患淋巴瘤或其他癌症的几率可能会增加。在使用TNF拮抗剂的儿童、青少年和年轻人中，出现一些不常见的恶性肿瘤病例，如罕见的可能导致死亡的肝脾T细胞淋巴瘤。另外，使用TNF拮抗剂（包括格乐立
                <span class="right_text">®</span>）过程中，患基底细胞癌和鳞状细胞癌的几率可能会增加，但是经治疗这些疾病通常不会危及生命。如果您有肿块（包括良性或恶性肿瘤）或未愈合伤口请告诉医生。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import navBar from "@/components/navBar.vue";
import footerBar from "@/components/footerBar.vue";
export default {
  name: "security",
  metaInfo: {
    title: "格乐立安全须知",
  },
  data () {
    return {};
  },
  components: {
    navBar,
    footerBar,
  },
  created () { },
  computed: {},
  methods: {},
};
</script>

<style lang="less">
.security {
  .right_text {
    font-size: 1rem;
    position: relative;
    top: -1.1rem;
    left: -0.6rem;
  }
  .banner {
    width: 100%;
    height: 13rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-image: url("../../../assets/article_bg.png");
  }
  .duty_text {
    display: flex;
    align-items: center;
    justify-content: center;
    .duty_content {
      padding: 1rem 0 4rem;
    }
    .title {
      font-size: 1.4rem;

      font-weight: 500;
      color: #3554aa;
      line-height: 2.5rem;
      .right_text {
        top: -0.7rem;
        left: -0.4rem;
      }
    }
    .content {
      font-size: 0.93rem;

      font-weight: 400;
      color: #3f3f3f;
      line-height: 2rem;
      .right_text {
        font-size: 0.7rem;
        top: -0.5rem;
        left: -0.2rem;
      }
      .cicle_content {
        display: flex;
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;

        p {
          margin: 0;
        }

        .circle {
          display: inline-flex;
          width: 5px;
          height: 5px;
          background: #3554aa;
          border-radius: 100%;
          margin-right: 0.5rem;
        }
      }
    }
  }
}
</style>
